<template>
  <div class="welcome-banner">
    <div class="banner-left">
      <h2 class="banner-title">{{ title }}</h2>
      <p class="banner-sub">{{ subtitle }}</p>
    </div>
    <div class="banner-right">
      <slot name="right" />
    </div>
  </div>
</template>

<script>
export default {
  name: 'WelcomeBanner',
  props: {
    title: { type: String, required: true },
    subtitle: { type: String, default: '' }
  }
}
</script>

<style lang="scss" scoped>
.welcome-banner {
  display: flex;
  justify-content: space-between;
  align-items: center;
  padding: 12px 24px;
  background: linear-gradient(135deg, #818cf8 0%, #a78bfa 100%);
  border-radius: 10px;
  margin-bottom: 16px;
  box-shadow: 0 2px 12px rgba(129, 140, 248, 0.25);

  .banner-left {
    display: flex;
    align-items: center;
    gap: 8px;
  }

  .banner-title { margin:0; font-size:16px; font-weight:600; color:#fff }
  .banner-sub { margin:0; font-size:13px; color:rgba(255,255,255,0.9) }

  .banner-right { display:flex; gap:8px; align-items:center }

  @media (max-width: 768px) {
    .welcome-banner { flex-direction: column; align-items: flex-start; }
    .banner-left { flex-direction: column; align-items: flex-start; gap: 4px; }
    .banner-right { width: 100%; display:flex; justify-content: flex-start; gap:8px; margin-top:8px }
  }
}
</style>
